<template>
  <div class="account-wrap border-bg">
    <el-tabs type="card" v-model="activeName">
      <el-tab-pane label="广告账户" name="ads">
        <ads-account v-if="activeName === 'ads'"></ads-account>
      </el-tab-pane>
      <el-tab-pane label="媒体账户" name="video">
        <video-account v-if="activeName === 'video'"></video-account>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AdsAccount from "./components/adsAccount.vue";
import VideoAccount from "./components/videoAccount.vue";
export default {
  components: {
    AdsAccount,
    VideoAccount,
  },

  data() {
    return {
      activeName: "ads",
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.account-wrap {
  margin: 16px;
  // height: 100%;
  background: #fff;
  padding: 16px;
}
</style>
